'use client';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { useTranslations } from 'next-intl';
import React from 'react';

export default function NotAvailableCard() {
  const t = useTranslations('');
  return (
    <div className="flex h-40 items-center justify-center gap-x-2 rounded-lg border bg-white p-6 text-lg font-medium shadow-sm">
      <ExclamationCircleIcon className="h-5 w-5" />
      {t('common.not_available')}
    </div>
  );
}
